import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '../../constants/colors';
import { isForeignCityCar } from '../../utils/foreignCityCar';

/**
 * ÐÐ¾ÑÐ¾Ð´ Ð¼Ð°ÑÐ¸Ð½Ñ Ð² ÑÐ¿Ð¸ÑÐºÐµ ÑÑÐ¾ÐºÐ°. ÐÑÐ»Ð¸ Ð¼Ð°ÑÐ¸Ð½Ð° Ð½Ðµ Ð¸Ð· Ð³Ð¾ÑÐ¾Ð´Ð¾Ð² ÑÐ¾ÑÑÑÐ´Ð½Ð¸ÐºÐ° â Ð¿Ð¾Ð¼ÐµÑÐ°ÐµÐ¼.
 *
 * Ð¡ÑÐ¾Ðº Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÑ ÑÐ¾Ð»ÑÐºÐ¾ ÑÐ²Ð¾Ð¸ Ð³Ð¾ÑÐ¾Ð´Ð°, Ð½Ð¾ Ð¿Ð¾Ð¸ÑÐº Ð¿Ð¾ Ð¿Ð¾Ð»Ð½Ð¾Ð¼Ñ VIN Ð½Ð°ÑÐ¾Ð´Ð¸Ñ Ð¼Ð°ÑÐ¸Ð½Ñ
 * Ð¾ÑÐºÑÐ´Ð° ÑÐ³Ð¾Ð´Ð½Ð¾: Ð¸Ð½Ð°ÑÐµ ÐµÑ Ð½Ðµ Ð¿ÐµÑÐµÐ½ÐµÑÑÐ¸ Ðº ÑÐµÐ±Ðµ. Ð Ð°Ð· Ð¼Ð°ÑÐ¸Ð½Ð° Ð½Ð°ÑÐ»Ð°ÑÑ, Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð¿Ð¾
 * Ð¿ÑÐ¸Ð²ÑÑÐºÐµ ÑÑÐ¸ÑÐ°ÐµÑ ÐµÑ ÑÐ²Ð¾ÐµÐ¹ â Ð¾ÑÑÑÐ´Ð° Ð¾ÑÐ¼ÐµÑÐºÐ° (24.10.2026, Ð¢Ð°ÑÐ°Ð·).
 */
export default function ForeignCityCell({ city }) {
  const userCities = useSelector((state) => state?.user?.cities);
  const foreign = isForeignCityCar(city?.id, userCities);

  if (!foreign) return <span>{city?.title ?? ''}</span>;

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', columnGap: '6px', flexWrap: 'wrap' }}>
      <span style={{ fontWeight: 600 }}>{city?.title ?? ''}</span>
      <span
        style={{
          backgroundColor: colors.orange,
          color: colors.white,
          borderRadius: '10px',
          padding: '1px 8px',
          fontSize: '11px',
          whiteSpace: 'nowrap',
        }}
        title="ÐÐ°ÑÐ¸Ð½Ð° ÑÑÐ¾Ð¸Ñ Ð² Ð´ÑÑÐ³Ð¾Ð¼ Ð³Ð¾ÑÐ¾Ð´Ðµ. Ð§ÑÐ¾Ð±Ñ ÑÐ°Ð±Ð¾ÑÐ°ÑÑ Ñ Ð½ÐµÐ¹, ÑÐ¼ÐµÐ½Ð¸ÑÐµ Ð³Ð¾ÑÐ¾Ð´ Ð² ÐºÐ°ÑÑÐ¾ÑÐºÐµ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ."
      >
        Ð´ÑÑÐ³Ð¾Ð¹ Ð³Ð¾ÑÐ¾Ð´
      </span>
    </span>
  );
}
